<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14389YD/tc-custom/9781439107362.jpg?1730518493870" alt="This image is the cover for the book Memory's Embrace"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Memory's Embrace
      </h1>
      <p class="bookDescription body article font2">
        <b>A classic Western romance from the beloved #1 <i>New York Times</i>–bestselling author—third in the epic historical series following <i>Corbin’s Fancy</i>.</b><br/><br/>In the wilderness of 1880s Oregon, beautiful Tess Bishop was captivated by the most fascinating stranger ever to drift into her small lumber town—a man as handsome and cultured as he was mysterious.<br/><br/>Soon she discovered he was really Keith Corbin—torn by a terrible grief, fleeing his memories and the rich privilege of his former life. Bravely, Tess helped him hide his identity, and willingly, she joined him on his flight. She vowed to make him forget the sorrow that kept him on the run . . . and free his soul at last for the sweet fullness of her love!<br/><br/><b>Praise for Linda Lael Miller</b><br/><br/>“Linda Lael Miller creates vibrant characters and stories I defy you to forget.” —Debbie Macomber, #1 <i>New York Times</i>–bestselling author<br/><br/>“Linda Lael Miller beautifully crafts stories that bring small-town America to life and peoples them with characters you really care about.” —<i>Romantic Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Linda Lael Miller
      </h2>
      
      <p class="authorDescription body article">The daughter of a town marshal, Linda Lael Miller is a #1 <I>New York Times</I> and <I>USA TODAY</I> bestselling author of more than one hundred historical and contemporary novels, most of which reflect her love of the West. Raised in Northport, Washington, Linda pursued her wanderlust, living in London and Arizona and traveling the world before returning to the state of her birth to settle down on a horse property outside Spokane. Published since 1983,&#160;Linda&#160;was awarded the prestigious Nora Roberts Lifetime Achievement Award in 2007 by the Romance Writers of America. She was recently inducted into the Wild West Heritage Foundation&#39;s Walk of Fame for her dedication to preserving the heritage of the Wild West. When not writing,&#160;Linda&#160;loves to focus her creativity on a wide variety of art projects. Visit her online at LindaLaelMiller.com and Facebook.com/OfficialLindaLaelMiller.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?09990432